import { createRequest } from '@/http'

// 自主分析 › Beta 驗收資料夾（Blob mis-beta）
const betaFolderRequest = createRequest({
  baseURL: '/api/betafolder'
})

/** @returns {Promise<{data: {name: string, size: number, mtime: string, uploadedBy: string}[]}>} */
export const getBetaFilesApi = () =>
  betaFolderRequest.get('/files').then((res) => res.data)

/** 5 分鐘有效的下載連結 */
export const getBetaDownloadUrlApi = (name) =>
  betaFolderRequest.get('/download', { params: { name } }).then((res) => res.data.data.url)

/** 上傳一律另存新檔（原檔名＋帳號＋時間），後端回實際存的檔名 */
export const uploadBetaFileApi = (root, folder, fileName, dataBase64) =>
  betaFolderRequest
    .post('/upload', { root, folder, fileName, dataBase64 })
    .then((res) => res.data)

/** 根因週報：{ roots: { 根目錄: [日期] }, files: { 日期: alarms.csv 原文 } } */
export const getBetaAlarmsApi = (params) =>
  betaFolderRequest.get('/alarms', { params }).then((res) => res.data.data)

/** 趨勢週報：{ roots: [根目錄], data: trend_overview.json } */
export const getBetaTrendApi = (root) =>
  betaFolderRequest.get('/trend', { params: { root } }).then((res) => res.data.data)
